/**
 * Actions
 */
// 新业务对象分组
export const GET_OBJECT_DETAIL = 'GET_OBJECT_DETAIL'

export const GET_NEW_OBJECT_GROUP = 'GET_NEW_OBJECT_GROUP'
export const ADD_NEW_OBJECT_GROUP = 'ADD_NEW_OBJECT_GROUP'
export const EDIT_NEW_OBJECT_GROUP = 'EDIT_NEW_OBJECT_GROUP'
export const DEL_NEW_OBJECT_GROUP = 'DEL_NEW_OBJECT_GROUP'

// 新业务对象
export const GET_NEW_OBJECT = 'GET_NEW_OBJECT'
export const ADD_NEW_OBJECT = 'ADD_NEW_OBJECT'
export const EDIT_NEW_OBJECT = 'EDIT_NEW_OBJECT'
export const DEL_NEW_OBJECT = 'DEL_NEW_OBJECT'
export const GET_NEW_OBJECT_DTL = 'GET_NEW_OBJECT_DTL'
export const BATCH_CREATE_OBJECT = 'BATCH_CREATE_OBJECT'
export const CHECK_CUSTOMIZE_FIELD = 'CHECK_CUSTOMIZE_FIELD'
export const GET_PURVIEW_OBJECT = 'GET_PURVIEW_OBJECT'

// 新业务对象字段
export const GET_NEW_OBJECT_FIELD = 'GET_NEW_OBJECT_FIELD'
export const ADD_NEW_OBJECT_FIELD = 'ADD_NEW_OBJECT_FIELD'
export const EDIT_NEW_OBJECT_FIELD = 'EDIT_NEW_OBJECT_FIELD'
export const DEL_NEW_OBJECT_FIELD = 'DEL_NEW_OBJECT_FIELD'
export const GET_OBJECT_FIELD = 'GET_OBJECT_FIELD'

// 系统对象
export const GET_SYSTEM_OBJECT = 'GET_SYSTEM_OBJECT'
export const GET_BUSINESS_OBJECT = 'GET_BUSINESS_OBJECT'

// 新服务分组
export const GET_NEW_SERVICE_GROUP = 'GET_NEW_SERVICE_GROUP'
export const ADD_NEW_SERVICE_GROUP = 'ADD_NEW_SERVICE_GROUP'
export const EDIT_NEW_SERVICE_GROUP = 'EDIT_NEW_SERVICE_GROUP'
export const DEL_NEW_SERVICE_GROUP = 'DEL_NEW_SERVICE_GROUP'

// 新服务
export const GET_NEW_SERVICE = 'GET_NEW_SERVICE'
export const ADD_NEW_SERVICE = 'ADD_NEW_SERVICE'
export const EDIT_NEW_SERVICE = 'EDIT_NEW_SERVICE'
export const DEL_NEW_SERVICE = 'DEL_NEW_SERVICE'

export const BUILD_PC = 'BUILD_PC'
export const GET_PC_VERSIONS = 'GET_PC_VERSIONS'
export const GET_PC_BUILD_HISTORY = 'GET_PC_BUILD_HISTORY'
export const CLOSE_MOCK = 'CLOSE_MOCK'

// 服务编排
export const GET_SERVICE_ARRANGE_GROUP = 'GET_SERVICE_ARRANGE_GROUP'
export const ADD_SERVICE_ARRANGE_GROUP = 'ADD_SERVICE_ARRANGE_GROUP'
export const EDIT_SERVICE_ARRANGE_GROUP = 'EDIT_SERVICE_ARRANGE_GROUP'
export const GET_SERVICE_ARRANGE = 'GET_SERVICE_ARRANGE'
export const ADD_SERVICE_ARRANGE = 'ADD_SERVICE_ARRANGE'
export const EDIT_SERVICE_ARRANGE = 'EDIT_SERVICE_ARRANGE'
export const DEL_SERVICE_ARRANGE = 'DEL_SERVICE_ARRANGE'
export const PUBLISH_SERVICE_ARRANGE = 'PUBLISH_SERVICE_ARRANGE'
export const OFFLINE_SERVICE_ARRANGE = 'OFFLINE_SERVICE_ARRANGE'
export const LOGIN_SERVICE_ARRANGE = 'LOGIN_SERVICE_ARRANGE'

// 演示数据
export const GET_MOCK_LIST = 'GET_MOCK_LIST'
export const GET_MOCK_TEMPLATE = 'GET_MOCK_TEMPLATE'
export const DELETE_MOCK_ITEM = 'DELETE_MOCK_ITEM'
export const CREATE_MOCK_OBJECT = 'CREATE_MOCK_OBJECT'
export const UPLOAD_MOCK_EXCELL = 'UPLOAD_MOCK_EXCELL'
export const UPDATE_MOCK_EXCELL = 'UPDATE_MOCK_EXCELL'

/**
 * Mutations
 */

// 导入对象和服务
export const IMPORT_OBJECT = 'IMPORT_OBJECT'
export const IMPORT_SERVICE = 'IMPORT_SERVICE'

export const GET_ENV_LIST = 'GET_ENV_LIST'
